import * as styles from './components/styles.scss';
import TaskListAssetView from './components/TaskListAssetView';
import type { TaskListPayload } from './schema/TaskListPayload';
import { getDefaultListId } from './utils/getDefaultListId';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { AssetAriaLabel, DEFAULT_MIN_ASSET_WIDTH, registerAsset } from 'owa-timestream-asset-sdk';
import { DefaultCommand } from 'owa-timestream-asset-sdk-types';
import { getListPickerElement } from 'owa-todo-list-common';
import { getDefaultTasksFolderDisplayName } from 'owa-todo-utils';
import { canUseToDoFeatures } from 'owa-todo-utils/lib/utils/moduleAccessUtils';
import {
    taskListAssetError,
    taskListAssetName,
    taskListAssetTooltip,
} from './tasklist.locstring.json';

const TASK_LIST_TYPE = 'tasklist';

export default registerAsset<TaskListPayload>({
    type: TASK_LIST_TYPE,
    iconName: ControlIcons.ToDoLogoOutline,
    isAssetEnabled: canUseToDoFeatures,
    getToolName: () => loc(taskListAssetName),
    getTooltip: () => loc(taskListAssetTooltip),
    getErrorMessage: () => loc(taskListAssetError),
    viewStyle: styles.viewWrapper,
    CanvasView: TaskListAssetView,
    createEmptyAsset: () => ({
        type: TASK_LIST_TYPE,
        width: DEFAULT_MIN_ASSET_WIDTH,
        height: 548,
        payload: {},
    }),
    unsupportedDefaultCommands: [DefaultCommand.Color, DefaultCommand.DueDate],
    getTitleString: () => '', // TODO VSO 93135: Allow disabling turning an asset into a task
    getSearchString: getTaskListFolderName,
    getAriaLabel: getTaskListAriaLabelName,
    assetResizeConfiguration: () => ({
        minHeight: 200,
    }),
});

function getTaskListFolderName(payload: TaskListPayload) {
    const selectedListId = payload.listId ?? getDefaultListId();
    return getListPickerElement(selectedListId)?.Name || getDefaultTasksFolderDisplayName();
}

function getTaskListAriaLabelName(payload: TaskListPayload) {
    return loc(
        AssetAriaLabel.assetAriaLabel,
        loc(taskListAssetName),
        getTaskListFolderName(payload)
    );
}
